import ShaparakRequestsGet from './Get'

export {
    ShaparakRequestsGet,
}